/* oxlint-disable react/jsx-key */
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import LineAutoTransmissionIcon from 'LuxKit/Icons/line/LineAutoTransmissionIcon'
import LineBoltAltIcon from 'LuxKit/Icons/line/LineBoltAltIcon'
import LineDashboardIcon from 'LuxKit/Icons/line/LineDashboardIcon'
import LineManualTransmissionIcon from 'LuxKit/Icons/line/LineManualTransmissionIcon'
import LinePumpIcon from 'LuxKit/Icons/line/LinePumpIcon'
import LineRefreshIcon from 'LuxKit/Icons/line/LineRefreshIcon'
import LineSuitcaseIcon from 'LuxKit/Icons/line/LineSuitcaseIcon'
import LineUserCircleIcon from 'LuxKit/Icons/line/LineUserCircleIcon'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import { rem } from 'polished'
import styled from 'styled-components'
import { useIntl } from 'react-intl'
import useCarHireLabels from 'hooks/CarHire/useCarHireLabels'

const QuickIconsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: ${rem(12)};
  row-gap: ${rem(4)};
`

const fuelTypeIconMap = new Map<App.CarHireVehicleFuelType, React.ReactElement>([

  ['Diesel', <LinePumpIcon />],

  ['Electric', <LineBoltAltIcon />],

  ['Hybrid', <LineRefreshIcon />],

  ['Petrol', <LinePumpIcon />],

  ['MultiFuel', <LineRefreshIcon />],

  ['PlugInHybrid', <LineRefreshIcon />],
])

interface Props {
  offer: App.CarHireOffer
  showMileage: boolean
}

function CarHireOfferTileVehicleDetailsCondensed(props: Props) {
  const { offer, showMileage } = props
  const intl = useIntl()
  const { carHireFuelTypeLabelMap } = useCarHireLabels()

  const transmissionLabel = offer.vehicle.transmission === 'Automatic'
    ? intl.formatMessage({
        id: 'oeWHYFkINZs3ppRwB1rY',
        defaultMessage: 'Auto',
        description: 'Automatic transmission type label for car hire vehicle',
      })
    : intl.formatMessage({
        id: '0uErceTgFLAx9hQknoyw',
        defaultMessage: 'Manual',
        description: 'Manual transmission type label for car hire vehicle',
      })

  const unlimitedMileageLabel = intl.formatMessage({
    id: 'oQn7t5-ui6yAge9-ldI1',
    defaultMessage: 'Unlimited mileage limit',
    description: 'Label indicating unlimited mileage for car hire vehicle',
  })

  const limitedMileageLabel = intl.formatMessage(
    {
      id: 'hT0LlN96vJz2cNggGKCt',
      defaultMessage: '{quantity}{unit}/{period} mileage',
      description: 'Label showing mileage limit for car hire vehicle, e.g. 300km/day mileage',
    },
    {
      quantity: offer.mileage.quantity,
      unit: offer.mileage.unit,
      period: offer.mileage.period,
    },
  )
  const fuelTypeLabel = carHireFuelTypeLabelMap.get(offer.vehicle.fuelType) ?? offer.vehicle.fuelType

  return <VerticalSpacer gap={4}>
    <QuickIconsContainer>
      <BodyTextBlock variant="medium" startIcon={<LineUserCircleIcon />}>{offer.vehicle.seats}</BodyTextBlock>
      <BodyTextBlock variant="medium" startIcon={<LineSuitcaseIcon />}>{offer.vehicle.luggage}</BodyTextBlock>
      <BodyTextBlock
        variant="medium"
        startIcon={offer.vehicle.transmission === 'Automatic' ? <LineAutoTransmissionIcon /> : <LineManualTransmissionIcon />}
      >
        {transmissionLabel}
      </BodyTextBlock>
      {offer.vehicle.fuelType !== 'Unspecified' && <BodyTextBlock
        variant="medium"
        startIcon={fuelTypeIconMap.get(offer.vehicle.fuelType)}
      >
        {fuelTypeLabel}
      </BodyTextBlock>}
    </QuickIconsContainer>
    {showMileage &&
      <BodyTextBlock variant="medium" startIcon={<LineDashboardIcon />}>
        {offer.mileage.unlimited ? unlimitedMileageLabel : limitedMileageLabel}
      </BodyTextBlock>}
  </VerticalSpacer>
}

export default CarHireOfferTileVehicleDetailsCondensed
